import { normalizeAddress } from "../../anyspend/utils/index.js";
export const buildPayload = (orderType, params) => {
    const { nft, tournament, payload, expectedDstAmount } = params;
    switch (orderType) {
        case "swap":
            return {
                expectedDstAmount,
            };
        case "mint_nft":
            if (nft?.type === "erc1155") {
                return {
                    contractAddress: normalizeAddress(nft.contractAddress),
                    nftPrice: nft?.price || "",
                    tokenId: nft.tokenId,
                    contractType: nft?.type,
                };
            }
            else if (nft?.type === "erc721") {
                return {
                    contractAddress: normalizeAddress(nft.contractAddress),
                    nftPrice: nft?.price || "",
                    tokenId: null,
                    contractType: nft?.type,
                };
            }
            else {
                throw new Error(`Invalid nft payload: ${JSON.stringify(nft)}`);
            }
        case "join_tournament":
            return {
                contractAddress: tournament?.contractAddress,
                entryPrice: tournament?.entryPriceOrFundAmount,
            };
        case "fund_tournament":
            return {
                contractAddress: tournament?.contractAddress,
                fundAmount: tournament?.entryPriceOrFundAmount,
            };
        case "custom":
            return { ...payload };
        case "custom_exact_in":
            return { ...payload, expectedDstAmount };
        case "hype_duel":
            return {
                expectedDstAmount,
            };
        default:
            throw new Error(`Invalid order type: ${orderType}`);
    }
};
export const buildMetadata = (orderType, params) => {
    const { srcToken, dstToken, nft, tournament, payload } = params;
    const baseMetadata = {
        srcToken,
        dstToken,
    };
    switch (orderType) {
        case "swap":
            return { ...baseMetadata };
        case "mint_nft":
            return { ...baseMetadata, nft };
        case "join_tournament":
        case "fund_tournament":
            return { ...baseMetadata, tournament };
        case "custom":
            return { ...baseMetadata, action: payload.action };
        case "custom_exact_in":
            return { ...baseMetadata, action: payload.action };
        case "hype_duel":
            return { ...baseMetadata };
        default:
            throw new Error(`Invalid order type: ${orderType}`);
    }
};
